import { useTranslations } from 'next-intl';
import { CollectionCard } from '~/components';
import type { DirectSaleOfferResponseDto } from '~/lib/api';
import { GetFinishedSaleOnMarketButton } from '~/module/home/components/get-finished-sale-on-market-button';

interface Props {
  sale: DirectSaleOfferResponseDto;
}

export function FinishedSaleCard({ sale }: Props) {
  const t = useTranslations('homepage.finished-sales');

  return (
    <CollectionCard
      key={sale.id}
      bottomContent={<GetFinishedSaleOnMarketButton />}
      brandName={sale.brandName}
      cardHeight={312}
      id={sale.collectionId}
      imagePosition={sale.collectionImagePosition === 'cover' ? 'cover' : 'contain'}
      imageSrc={sale.collectionImage}
      label={t('sold-out')}
      rarity={sale.collectionRarity}
      title={sale.collectionName}
    />
  );
}
